import { render, staticRenderFns } from "./productMsgDialog.vue?vue&type=template&id=7966f1f5&scoped=true"
import script from "./productMsgDialog.vue?vue&type=script&lang=js"
export * from "./productMsgDialog.vue?vue&type=script&lang=js"
import style0 from "./productMsgDialog.vue?vue&type=style&index=0&id=7966f1f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7966f1f5",
  null
  
)

export default component.exports